import { Link } from "react-router-dom";
import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { LEGAL, ph } from "@/config/legal";

const Owner = () => (
  <ul className="list-none pl-0 space-y-1" data-testid="legal-owner-data">
    <li><strong>Titolare:</strong> <span data-testid="legal-ragione-sociale">{ph(LEGAL.ragioneSociale, "Ragione sociale")}</span></li>
    <li><strong>Partita IVA:</strong> {ph(LEGAL.partitaIva, "Partita IVA")}</li>
    <li><strong>Sede:</strong> {ph(LEGAL.sede, "Sede")}</li>
    <li><strong>Email:</strong> {LEGAL.email ? <a href={`mailto:${LEGAL.email}`} className="underline text-forest">{LEGAL.email}</a> : ph("", "Email")}</li>
  </ul>
);

export default function PrivacyPage() {
  return (
    <LegalLayout title="Privacy Policy" testId="privacy-page">
      <p className="text-sm sm:text-base text-ink/80 leading-relaxed">
        La presente informativa descrive le modalità di trattamento dei dati personali degli utenti che consultano il sito Progetto HOSPITALITY{LEGAL.siteUrl ? <> (<a href={LEGAL.siteUrl} className="underline text-forest" data-testid="privacy-site-url">{LEGAL.siteUrl.replace(/^https?:\/\//, "")}</a>)</> : null}
        e che inviano una richiesta tramite il modulo di contatto, ai sensi del Regolamento (UE) 2016/679 (GDPR).
      </p>

      <LegalSection title="1. Titolare del trattamento"><Owner /></LegalSection>

      <LegalSection title="2. Dati raccolti">
        <p>Attraverso il modulo "Raccontaci il tuo progetto" raccogliamo i dati che l'utente inserisce volontariamente:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>nome e cognome, indirizzo email, numero di telefono, comune/provincia;</li>
          <li>dati sulla struttura o sul progetto (tipologia, situazione, numero camere, fatturato annuo e occupazione media se indicati, obiettivi);</li>
          <li>il contenuto del messaggio.</li>
        </ul>
        <p>Durante la navigazione possono essere trattati dati tecnici (indirizzo IP in forma pseudonimizzata, dati di log) necessari al funzionamento e alla sicurezza del sito, inclusa la prevenzione di invii automatici.</p>
      </LegalSection>

      <LegalSection title="3. Finalità del trattamento">
        <p>I dati inseriti nel modulo sono trattati esclusivamente per ricontattare l'utente e fornire riscontro alla richiesta di consulenza, approfondendo il progetto descritto.</p>
      </LegalSection>

      <LegalSection title="4. Base giuridica">
        <p>Il trattamento si fonda sul consenso dell'interessato (art. 6, par. 1, lett. a GDPR), espresso tramite l'apposita casella del modulo. Il consenso può essere revocato in qualsiasi momento, senza pregiudicare la liceità del trattamento effettuato prima della revoca.</p>
      </LegalSection>

      <LegalSection title="5. Conservazione dei dati">
        <p>I dati sono conservati per il tempo necessario a gestire la richiesta e per un periodo massimo di {LEGAL.conservazioneMesi} mesi dall'ultimo contatto, salvo diversi obblighi di legge o l'instaurazione di un rapporto contrattuale.</p>
      </LegalSection>

      <LegalSection title="6. Destinatari dei dati">
        <p>I dati possono essere trattati da fornitori tecnici che operano per conto del Titolare in qualità di responsabili del trattamento, in particolare: il fornitore di hosting e database e il servizio di invio delle email di notifica. I dati non sono diffusi né ceduti a terzi per finalità proprie.</p>
      </LegalSection>

      <LegalSection title="7. Diritti dell'interessato">
        <p>Ai sensi degli artt. 15-22 GDPR, l'interessato ha diritto di ottenere l'accesso ai propri dati, la rettifica, la cancellazione, la limitazione del trattamento, la portabilità, nonché di opporsi al trattamento e di revocare il consenso.</p>
        <p>Per esercitare i diritti è sufficiente scrivere a {LEGAL.email ? <a href={`mailto:${LEGAL.email}`} className="underline text-forest" data-testid="privacy-rights-email">{LEGAL.email}</a> : ph("", "Email")}. È inoltre possibile proporre reclamo al Garante per la protezione dei dati personali.</p>
      </LegalSection>

      <LegalSection title="8. Cookie">
        <p>Il sito utilizza cookie tecnici necessari e, solo previo consenso, cookie di analisi e marketing. Per i dettagli e per modificare le preferenze consulta la <Link to="/cookie" className="underline text-forest" data-testid="privacy-to-cookie-link">Cookie Policy</Link>.</p>
      </LegalSection>
    </LegalLayout>
  );
}
